import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    targetTime: String
  }

  connect() {
    this.update()
    this.timer = setInterval(() => {
      this.update()
    }, 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  update() {
    const target = new Date(this.targetTimeValue)
    const now = new Date()
    const diff = Math.max(0, Math.floor((target - now) / 1000))

    if (diff <= 0) {
      this.element.textContent = "0с"
      clearInterval(this.timer)
      return
    }

    const minutes = Math.floor(diff / 60)
    const seconds = diff % 60

    if (minutes > 0) {
      this.element.textContent = `${minutes}м ${seconds}с`
    } else {
      this.element.textContent = `${seconds}с`
    }
  }
}
